/** Small display helpers shared by the chat and its hosts. */

export function money(n: number | null | undefined): string {
  return n == null ? '—' : `$${n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;
}

export function aiStatusLabel(status: string | null | undefined, t: (k: string, o?: Record<string, unknown>) => string): string {
  if (!status) return t('ai.unknown');
  if (status === 'chatting') return t('ai.chatting');
  if (status === 'ignored') return t('ai.ignored');
  if (status.startsWith('handed_off:')) return t('ai.handedOff', { reason: t(`reasons.${status.slice('handed_off:'.length)}`, { defaultValue: status.slice('handed_off:'.length).replace(/_/g, ' ') }) });
  return status;
}
